import type { AppFile } from '@lib/types/app'
import { useQuery } from '@tanstack/vue-query'

export const useFetchApps = (fetcher: (params: any) => Promise<AppFile[]>) =>
  useQuery<AppFile[]>(['canvas-builder-apps'], fetcher, {
    keepPreviousData: true,
  })
